import React from 'react'
import { useTheme } from '../mui/Styles/index'
import { siteMapUrls } from '../../constants/site-map'
import { Box } from '../mui/Core/index'
import Constants from '../../constants/en.json'

export function SiteMap() {
  const theme = useTheme()
  const rootStyle = { display: 'flex', gap: '68px' }
  const linkStyle = {
    fontSize: '16px',
    letterSpacing: '0.4px',
    color: theme.palette.secondary.main,
  }

  return (
    <Box style={rootStyle}>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={siteMapUrls.url.TERMS_OF_USE_URL}
        style={linkStyle}
      >
        {Constants.siteMap.TERMS_OF_USE}
      </a>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={siteMapUrls.url.PRIVACY_POLICY_URL}
        style={linkStyle}
      >
        {Constants.siteMap.PRIVACY_POLICY}
      </a>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={siteMapUrls.url.TRADEMARKS_URL}
        style={linkStyle}
      >
        {Constants.siteMap.TRADEMARKS}
      </a>
    </Box>
  )
}

export default SiteMap
